import api from './api';

const favoriteService = {
  // Get all favorites
  async getAllFavorites() {
    try {
      const response = await api.get('/favorites/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch favorites'
      };
    }
  },

  // Check favorite status for multiple items
  async checkFavorites(productIds = [], serviceIds = [], partnerIds = []) {
    try {
      const params = new URLSearchParams();
      productIds.forEach(id => params.append('product_ids[]', id));
      serviceIds.forEach(id => params.append('service_ids[]', id));
      partnerIds.forEach(id => params.append('partner_ids[]', id));

      const response = await api.get(`/favorites/check/?${params.toString()}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to check favorites'
      };
    }
  },

  // Product favorites
  async getFavoriteProducts() {
    try {
      const response = await api.get('/favorites/products/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch favorite products'
      };
    }
  },

  async addFavoriteProduct(productId) {
    try {
      const response = await api.post('/favorites/products/', { product_id: productId });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add to favorites'
      };
    }
  },

  async removeFavoriteProduct(productId) {
    try {
      await api.delete(`/favorites/products/${productId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to remove from favorites'
      };
    }
  },

  // Service favorites
  async getFavoriteServices() {
    try {
      const response = await api.get('/favorites/services/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch favorite services'
      };
    }
  },

  async addFavoriteService(serviceId) {
    try {
      const response = await api.post('/favorites/services/', { service_id: serviceId });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add to favorites'
      };
    }
  },

  async removeFavoriteService(serviceId) {
    try {
      await api.delete(`/favorites/services/${serviceId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to remove from favorites'
      };
    }
  },

  // Partner favorites
  async getFavoritePartners() {
    try {
      const response = await api.get('/favorites/partners/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch favorite partners'
      };
    }
  },

  async addFavoritePartner(partnerId) {
    try {
      const response = await api.post('/favorites/partners/', { partner_id: partnerId });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add to favorites'
      };
    }
  },

  async removeFavoritePartner(partnerId) {
    try {
      await api.delete(`/favorites/partners/${partnerId}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to remove from favorites'
      };
    }
  }
};

export default favoriteService;
